import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

// 注册i18n实例并引入语言文件
const i18n = new VueI18n({
  locale: 'japanese',
  fallbackLocale: 'japanese',
  messages: {
    'zh_cn': require('@/assets/languages/zh_cn.json'),
    'en_us': require('@/assets/languages/en_us.json'),
    'japanese': require('@/assets/languages/japanese.json')
  }
})

export default i18n



// WEBPACK FOOTER //
// ./src/assets/i18n/index.js